<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Add In Out Master</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-switch @change="inst_details = ''" v-model="apply_proceed"
                        label="Apply In Out Master"></v-switch>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="emp" :items="emp_list"
                            item-text="name" item-value="id" label="Employee" outlined persistent-hint
                            hint="Please Select Employee" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="emp_type" :items="emp_type_list"
                            item-text="name" item-value="id" label="Employee Type" outlined persistent-hint
                            hint="Please Select Employee Type" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee Designation</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="designation"
                            :items="designation_list" item-text="name" item-value="id" label="Employee Designation"
                            outlined persistent-hint hint="Please Select Employee Designation" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section"
                            :items="emp_section_list" item-text="name" item-value="id" label="Employee Section" outlined
                            persistent-hint hint="Please Select Employee Section" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Employee Shift</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="shift" :items="emp_shift_list"
                            item-text="name" item-value="id" label="Employee Shift" outlined persistent-hint
                            hint="Please Select Employee Shift" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>In Out Plan Master</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="plan_master"
                            :items="plan_master_list" item-text="name" item-value="id" label="In Out Plan Master"
                            outlined persistent-hint hint="Please Select In Out Plan Master" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="apply_proceed">
                        <!-- from date -->
                        <p><v-icon color="error">*</v-icon><b>Apply Plan From Date</b></p>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field dense outlined rounded v-model="new_from_date"
                                    @blur="date1 = parseDate(new_from_date)" v-on="on" prepend-icon="event"
                                    persistent-hint label="From Date"></v-text-field>
                            </template>
                            <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="apply_proceed">
                        <!-- to date -->
                        <p><v-icon color="error">*</v-icon><b>Apply Plan To Date</b></p>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field dense outlined rounded v-model="new_to_date"
                                    @blur="date2 = parseDate(new_to_date)" v-on="on" prepend-icon="event"
                                    persistent-hint label="To Date"></v-text-field>
                            </template>
                            <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-4 mt-5" v-if="ay != null && plan_master != null">
                        <span v-if="apply_proceed && new_from_date!='' && new_to_date!=''">
                            Fetch Employee For Selected Plan<input type="checkbox" :value="plan_applied_emp"
                                v-model="plan_applied_emp" />
                            <v-btn class="button" @click="getEmpDeatils()">Proceed</v-btn>
                        </span>
                        <v-btn class="button" v-if="!apply_proceed" @click="getEmpDeatils()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="inst_details != ''">
                <v-row dense v-if="inst_details != ''">
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search1" append-icon="mdi-magnify"
                            label="Search by Employee Name or by Employee Code" single-line hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-col cols="12" sm="12" md="12" v-if="inst_details != ''">
                    <div id="my-table-id">
                        <v-simple-table fixed-header dense class="elevation-1" height="500px" v-if="!apply_proceed">
                            <thead>
                                <tr>
                                    <th align="center">
                                        <label class="form-checkbox">
                                            <input type="checkbox" v-model="selectAll" @click="select()" />
                                            <i class="form-icon"></i>
                                        </label>
                                    </th>
                                    <th class="">Sr. No.</th>
                                    <th class="">Name</th>
                                    <th class="">Employee Designation</th>
                                    <th class="">Employee Type</th>
                                    <th class="">Employee Section</th>
                                    <th class="">Date Of Joining</th>
                                    <th class="">
                                        Already applied In Out Plan (Only Name Of Plan)
                                    </th>
                                    <!-- <th v-for="(s, index) in dateheader" :key="index">
                    {{ s.day }} <br />
                    {{ s.date }}
                  </th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr></tr>
                                <tr v-for="(s, index) in filteredItems" :key="s.instid">
                                    <td>
                                        <label class="form-checkbox">
                                            <input type="checkbox" :value="s.instid" v-model="s.inst_select" />
                                            <i class="form-icon"></i>
                                        </label>
                                    </td>
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.inst_designation }}</td>
                                    <td>{{ s.inst_employeetype }}</td>
                                    <td>{{ s.inst_employeesection }}</td>
                                    <td>{{ s.inst_date_of_joining }}</td>
                                    <td>{{ s.inst_in_out_plan }}</td>
                                    <!-- <td v-for="(date,index1) in s.dates" :key="index1" v-if="date.isweeklyoff" style="background: yellow;"> -->
                                    <!-- <td
                    v-for="(date, index1) in s.dates"
                    :key="index1"
                    :class="date.isweeklyoff ? 'weaklyoff2' : 'weaklyoff'"
                  >
                    {{ date.intime }} To {{ date.outtime }}
                  </td> -->
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-simple-table fixed-header dense class="elevation-1" height="500px" v-else>
                            <thead>
                                <tr>
                                    <th align="center">
                                        <label class="form-checkbox">
                                            <input type="checkbox" v-model="selectAll" @click="select()" />
                                            <i class="form-icon"></i>
                                        </label>
                                    </th>
                                    <th class="">Sr. No.</th>
                                    <th class="">Name</th>
                                    <th class="">Employee Designation</th>
                                    <th class="">Employee Type</th>
                                    <th class="">Employee Section</th>
                                    <th class="">Date Of Joining</th>
                                    <th class="">
                                        Already applied In Out Plan (Only Name Of Paln)
                                    </th>
                                    <!-- <th v-for="(s, index) in dateheader" :key="index">
                                        {{ s.day }} <br />
                                        {{ s.date }}
                                    </th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr></tr>
                                <tr v-for="(s, index) in filteredItems" :key="s.instid">
                                    <td>
                                        <label class="form-checkbox">
                                            <input type="checkbox" :value="s.instid" v-model="s.inst_select" />
                                            <i class="form-icon"></i>
                                        </label>
                                    </td>
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.inst_designation }}</td>
                                    <td>{{ s.inst_employeetype }}</td>
                                    <td>{{ s.inst_employeesection }}</td>
                                    <td>{{ s.inst_date_of_joining }}</td>
                                    <td>{{ s.inst_in_out_plan }}</td>
                                    <!-- <td v-for="(date,index1) in s.dates" :key="index1" v-if="date.isweeklyoff" style="background: yellow;"> -->
                                    <!-- <td v-for="(date, index1) in s.dates" :key="index1" :class="date.isweeklyoff ? 'weaklyoff2' : 'weaklyoff'">
                                        {{ date.intime }} To {{ date.outtime }}
                                    </td> -->
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                    <center>
                        <v-btn v-if="apply_proceed" class="button"
                            @click="saveDefaultAttendanceTimeWithInOutMaster()">Save</v-btn>
                    </center>
                </v-col>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Holiday from "../Admin/Holiday";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            holiday: Holiday,
            Breadcrumbs
        },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            ay_list: [],
            // extraBreadcrumbItems: [

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            ay: "",
            emp_type_list: [],
            emp_type: null,
            designation_list: [],
            designation: null,
            emp_section_list: [],
            section: null,
            emp_list: [],
            emp: null,
            inst_details: [],
            selected: [],
            selectAll: false,
            search1: "",
            plan_master_list: [],
            plan_master: null,
            dateheader: [],
            apply_proceed: false,
            selected_inst_id: [],
            plan_applied_emp: true,
            emp_shift_list: [],
            shift: null,
            new_from_date: "",
            new_to_date: "",
            new_due_date: "",
            date1: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            date3: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            menu3: false,
            menu11: false,
            menu22: false,
            menu33: false,
        }),
        watch: {
            date1(val) {
                this.new_from_date = this.formatDate(this.date1);
            },
            date2(val) {
                this.new_to_date = this.formatDate(this.date2);
            },
        },
        methods: {
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            select() {
                this.selected = [];
                for (let i in this.inst_details) {
                    this.inst_details[i].inst_select = false;
                }
                if (!this.selectAll) {
                    for (let i in this.inst_details) {
                        this.selected.push(this.inst_details[i].instid);
                        this.inst_details[i].inst_select = true;
                    }
                }
            },
            saveDefaultAttendanceTimeWithInOutMaster() {
                this.selected_inst_id = [];
                for (let i in this.inst_details) {
                    if (this.inst_details[i].inst_select == true) {
                        this.selected_inst_id.push(this.inst_details[i].instid);
                    }
                }
                // console.log("2222"+this.selected_inst_id)
                if (!confirm("Selected Employee :: " + this.selected_inst_id.length + ". Want to proceed...?")) return;
                const data = {
                    ay: this.ay,
                    selected: this.selected_inst_id,
                    plan_master: this.plan_master,
                    from_date: this.new_from_date,
                    to_date: this.new_to_date,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveDefaultAttendanceTimeWithInOutMaster", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Default In Out Time Added Successfully In Employee Attendance!!");
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            getEmpDeatils() {
                const data = {
                    ay: this.ay,
                    emp_type: this.emp_type,
                    designation: this.designation,
                    section: this.section,
                    emp: this.emp,
                    plan_master: this.plan_master,
                    apply_proceed: this.apply_proceed,
                    plan_applied_emp: this.plan_applied_emp,
                    shift: this.shift,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/getEmpDeatilsToAddInOutMaster", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.inst_details = res.data.inst_details;
                            //  this.dateheader = res.data.dateheader;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("EmployeeBiometric/createEmployeeAttendance")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.aylist), (this.ay = res.data.curreny_ay);
                            this.emp_type_list = res.data.emp_type_list;
                            this.designation_list = res.data.designation_list;
                            this.emp_section_list = res.data.emp_section_list;
                            this.plan_master_list = res.data.plan_master_list;
                            this.emp_shift_list = res.data.emp_shift_list;
                            this.emp_list = res.data.emp_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        computed: {
            filteredItems() {
                return this.inst_details.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 || item.employee_code.toLowerCase().indexOf(this.search1.toLowerCase()) > -1;
                });
            },
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #2980b9 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #2980b9 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .weaklyoff {
        background: white !important;
    }
    .weaklyoff2 {
        background: yellow !important;
    }
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
